// Lazy load function
const lazyLoad = (file) => () =>
    import(
      /* webpackChunkName: "[request]" */ `@/views/purchasing/grid-reports/${file}.vue`
    );

export default [
    {
        path: '/goods-in-interrogation',
        name: 'goods-in-interrogation',
        meta: { requiresAuth: true, applicationFeatureCode: "GoodsIn" },
        components: {
            content: lazyLoad('goods-in-interrogation'),
        },
    },
    {
        path: '/purchase-order-interrogation',
        name: 'purchase-order-interrogation',
        meta: { requiresAuth: true, applicationFeatureCode: "PurchaseOrder" },
        components: {
            content: lazyLoad('purchase-order-interrogation'),
        },
    }
]